import ComboWizard from '../shared/combo-wizard'
import { interpretStep } from './functions'
import { CLARIDAD_DIRECCION_NAME, CLARIDAD_DIRECCION_STEPS } from './combo-config'

const ClaridadDireccion = () => (
    <ComboWizard
        comboName={CLARIDAD_DIRECCION_NAME}
        steps={CLARIDAD_DIRECCION_STEPS}
        bgClass="bg-claridad-direccion"
        interpretStep={interpretStep}
        consultaPlaceholder="Dilema, consulta o inquietud del consultante (opcional). Se usará en las 3 tiradas del combo."
    />
)

export default ClaridadDireccion
